import type { ReactNode } from "react";

/** Visual chrome that wraps each onboarding page. Light, embed-friendly. */
export function Shell({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  return (
    <div className="min-h-screen flex items-start justify-center px-6 py-10">
      <div className="w-full max-w-2xl">
        <header className="mb-8">
          <h1
            className="text-3xl font-semibold"
            style={{ fontFamily: "var(--font-display)", color: "var(--color-fg)" }}
          >
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-sm" style={{ color: "var(--color-muted)" }}>{subtitle}</p>}
        </header>
        <main
          className="rounded-xl border p-6"
          style={{
            background: "var(--color-card)",
            borderColor: "var(--color-border)",
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
